export const checkConnectivity = () => {
  return fetch("https://www.google.com/", { mode: "no-cors" });
};
